import { render, staticRenderFns } from "./lottery-popup-step.vue?vue&type=template&id=2592803a&scoped=true&"
import script from "./lottery-popup-step.vue?vue&type=script&lang=js&"
export * from "./lottery-popup-step.vue?vue&type=script&lang=js&"
import style0 from "./lottery-popup-step.vue?vue&type=style&index=0&id=2592803a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592803a",
  null
  
)

export default component.exports